export default function NotFount(){
    return <div>
        <h3>Page not found</h3>
    </div>
}